import { questionConstants, answerConstants } from '../_constants';
import { questionService } from '../_services';
import { alertActions } from '.';

export const questionActions = {
  postQuestion,
  postAnswer,
  getById,
  getAll,
  getByUser,
  updateQuestion,
  updateAnswer,
  delete: _delete
};

function getById(id) {

  return dispatch => {
    dispatch(request({ id }));

    questionService.getById(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(id) { return { type: questionConstants.GET_REQUEST, id } }
  function success(question) { return { type: questionConstants.GET_SUCCESS, question } }
  function failure(error) { return { type: questionConstants.GET_FAILURE, error } }
}

function postQuestion(question) {
  return dispatch => {
    dispatch(request(question));

    questionService.postQuestion(question)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Question post successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(question) { return { type: questionConstants.REGISTER_REQUEST, question } }
  function success(question) { return { type: questionConstants.REGISTER_SUCCESS, question } }
  function failure(error) { return { type: questionConstants.REGISTER_FAILURE, error } }
}

function postAnswer(answer) {
  return dispatch => {
    dispatch(request(answer));

    questionService.postAnswer(answer)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Answer post successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(answer) { return { type: answerConstants.REGISTER_REQUEST, answer } }
  function success(answer) { return { type: answerConstants.REGISTER_SUCCESS, answer } }
  function failure(error) { return { type: answerConstants.REGISTER_FAILURE, error } }
}

function getAll(api_params) {
  return dispatch => {
    dispatch(request());

    questionService.getAll(api_params)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response))
          }
        }
      );
  };

  function request() { return { type: questionConstants.GETALL_REQUEST } }
  function success(questions) { return { type: questionConstants.GETALL_SUCCESS, questions } }
  function failure(error) { return { type: questionConstants.GETALL_FAILURE, error } }
}

function getByUser($page=1, $user_id=0) {
  return dispatch => {
    dispatch(request());

    questionService.getByUser($page, $user_id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response))
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response))
          }
        }
      );
  };

  function request() { return { type: questionConstants.GETALL_REQUEST } }
  function success(questions) { return { type: questionConstants.GETALL_SUCCESS, questions } }
  function failure(error) { return { type: questionConstants.GETALL_FAILURE, error } }
}

function updateQuestion(question) {
  return dispatch => {
    dispatch(request(question));

    questionService.updateQuestion(question)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Updated successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(question) { return { type: questionConstants.REGISTER_REQUEST, question } }
  function success(question) { return { type: questionConstants.REGISTER_SUCCESS, question } }
  function failure(error) { return { type: questionConstants.REGISTER_FAILURE, error } }
}

function updateAnswer(answer) {
  return dispatch => {
    dispatch(request(answer));

    questionService.updateAnswer(answer)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(response));
            dispatch(alertActions.success('Updated successful'));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(response));
            dispatch(alertActions.error(response));
          }
        }
      );
  };

  function request(answer) { return { type: answerConstants.REGISTER_REQUEST, answer } }
  function success(answer) { return { type: answerConstants.REGISTER_SUCCESS, answer } }
  function failure(error) { return { type: answerConstants.REGISTER_FAILURE, error } }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  return dispatch => {
    dispatch(request(id));

    questionService.delete(id)
      .then(
        response => {
          if(response.success === true) {
            dispatch(success(id));
          }
          else if(response.errors !== undefined && Object.keys(response.errors).length > 0) {
            dispatch(failure(id, response));
          }
        }
      );
  };

  function request(id) { return { type: questionConstants.DELETE_REQUEST, id } }
  function success(id) { return { type: questionConstants.DELETE_SUCCESS, id } }
  function failure(id, error) { return { type: questionConstants.DELETE_FAILURE, id, error } }
}
